import { z } from "zod";
import { RequestTypeDtoSchema } from "./RequestTypeDto";
import { TaxonomyDtoSchema } from "./TaxonomyDto";
import { RequestStateDtoSchema } from "./RequestStateDtoSchema";
import { RequestParameterDtoSchema } from "./RequestParameterDto";
import { RequestFileDtoSchema } from "./RequestFileDto";
import { RequestMagicLinkMethodSchema } from "../Enums/RequestMagicLinkMethod";
import { RequestFieldsRelationOutputSchema } from "./RequestFieldsRelationOutput";

export const RequestDetailOutputSchema = z.object({
    requestId: z.string(),
    stateAnswer: z.string().nullish(),
    requestState: z.array(RequestStateDtoSchema).nullish(),
    requestData: RequestTypeDtoSchema.nullish(),
    fieldDetails: z.array(RequestParameterDtoSchema).nullish(),
    taxonomy: z.array(TaxonomyDtoSchema).nullish(),
    files: z.array(RequestFileDtoSchema).nullish(),
    isSubmitted: z.boolean(),
    shouldBeNotified: z.boolean(),
    attachmentsRequired: z.boolean(),
    attachmentsEnabled: z.boolean(),
    hasGeneratedDocument: z.boolean(),
    isMy: z.boolean().nullish(),
    manualSignRequired: z.boolean().nullish(),
    isMagicLinkAvailable: z.boolean().nullish(),
    magicLinkStartedAt: z.string().nullish(),
    isMagicLinkSigningActive: z.boolean().nullish(),
    magicLinkSendMethod: RequestMagicLinkMethodSchema.nullish(),
    magicLinkRecipient: z.string().nullish(),
    fieldsRelation: RequestFieldsRelationOutputSchema.nullish(),
});

export type RequestDetailOutput = z.infer<typeof RequestDetailOutputSchema>;
